import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Label, Input, Form } from "reactstrap";
import { inject, observer } from 'mobx-react';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatarReal } from '../../../utils/formatar';
import Card from '../../comum/components/Card';
import { LoadingWhapper } from '../../comum/loading/components';
import { IconeAtencao, IconeGenerico, IconeMailBulk, IconeSetaEsquerda, Pdf } from '../../comum/components/Icones';
import Tooltip from '../../comum/components/Tooltip';
import { E_TIPO_TELA } from '../stores/Enum';
import HelpButton from '../../comum/components/HelpButton';

@inject("store")
@observer
export default class ResultadoSimulacao extends Component {
    constructor(props) {
        super(props);

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.dataStore = this.props.controllers.dataStore;
        this.filterStore = this.props.controllers.filterStore;
        this.viewStore = this.props.controllers.viewStore;
        this.emailStore = this.props.controllers.emailStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo(this.dataStore.dadosModalidade.Titulo);
    }

    renderCodGrupo = (cell, row) => {
        return (
            <Tooltip tooltipText={row.DescGrupoServico} style={{ width: '100px', left: '-100px', backgroundColor: 'gray', textAlign: 'left'}} bottom >
                {row.CodGrupoServico}
            </Tooltip>
        )        
    }

    renderCodEstrutura = (cell, row) => {
        return (
            <Tooltip tooltipText={row.DescEstruturaServico} style={{ marginLeft: '50px' , backgroundColor: 'gray', textAlign: 'left'}} bottom >
                {row.CodEstruturaServico}
            </Tooltip>
        )        
    }

    colunas = [
        {
            dataField: "CodGrupoServico",
            text: "Cód. Antaq",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: this.renderCodGrupo,
        }, 
        {
            dataField: "CodEstruturaServico",
            text: "Cód. Tecon",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: this.renderCodEstrutura,
        }, 
        {
            dataField: "Servico",
            text: "Serviço",
            headerAlign: () => 'left',
            align: () => "left",
        }, 
        {
            dataField: "Valor",
            text: "Valor Unitário",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: cellContent => formatarReal(cellContent)
        }, 
        {
            dataField: "Qtd",
            text: "Unidade",
            headerAlign: () => 'center',
            align: () => "center",
        }, 
        {
            dataField: "Total",
            text: "Valor Total",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: cellContent => formatarReal(cellContent)
        },
        {
            dataField: "Iss",
            text: "Iss",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: cellContent => `${cellContent}%`
        }
    ];

    colunasImpNacional = [
        {
            dataField: "Pis",
            text: "Pis",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: cellContent => `${cellContent}%`
        },
        {
            dataField: "Cofins",
            text: "Cofins",
            headerAlign: () => 'left',
            align: () => "left",
            formatter: cellContent => `${cellContent}%`
        }
    ];
    
    

    downloadResumo = async () => {

        const loadingModal = this.modalStore.openNewConfigurableModal({ loading: true });

        const { error } = await this.emailStore.carregarCalculadoraResumo(this.dataStore.dadosModalidade);

        if (error) {
            loadingModal.appendConfigurableModal({ 
                title: 'Erro!',
                body: <p>{error}</p>,
                hideCancel: true,
                loading: false,
            });   
        }
        else {
            loadingModal.destroy();
        }
    } 

    handleEmailClick = async () => {
        this.emailStore.setDataPdf(this.dataStore.dadosModalidade);

        const emailModal = this.modalStore.openNewConfigurableModal("Atenção!", {
            className: "tamanho-modal-500",
            body: <Fragment key='fr-1'>
                <Form onSubmit={handleSubmitAndClose.bind(this)} key='for-1'>
                    <Row className="px-3" key='r-1'>
                        <p>Insira e-mails separados por ";" para recebimento de notificações.</p>
                    </Row>
                    <Row key='r-2'>
                        <Col className="py-2 px-3" key='col-1'>
                            <Label className="w-100" key='l-1'>E-mail(s)
                                <Input key='i-1'
                                    name="emails"
                                    type="textarea"
                                />
                            </Label>
                            <div key='dv-1' className="d-flex">
                                <span key='sp-1' className="label-danger">* </span>
                                <p key='p-1'>Obs.: Esse e-mail não será utilizado para nenhum fim.</p>
                            </div>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end" key={8}>
                        <Button key='b-1' className="btn-primary btn-modal-cancelar" onClick={closeModal}>CANCELAR</Button>
                        <Button key='b-2' type="submit" className="btn-primary btn-modal-confirmar">ENVIAR</Button>
                    </div>
                </Form>
            </Fragment>,
            hideOk: true,
            hideCancel: true,
        });

        async function handleSubmitAndClose(event) {
            event.preventDefault();
            const form = event.target;
            const { emails: { value: emails }} = form.elements;
            
            emailModal.appendConfigurableModal({ loading:true, className: "" });

            const { error } = await this.emailStore.enviarEmailSimulacao(emails.replace(' ','').trim());

            emailModal.destroy();
            this.modalStore.openNewConfigurableModal(!error ? 'E-mail enviado com sucesso!' : 'Erro!', {
                body: error ? <p>{error}</p> : null,
                hideCancel: true,
                onClickOk: () => !error,
            });
        }

        function closeModal() {
            emailModal.destroy();
        }
    }

    voltarClick() {
        this.viewStore.alteraTela(this.filterStore.modalidade);
    }

    novaSimulacao() {
        this.modalStore.openNewConfigurableModal('Alerta!', {
            body: <p>Deseja limpar as informações e iniciar uma nova simulação?</p>,
            okLabel: "SIM",
            cancelLabel: "NÃO",
            onClickOk: this.resetarSimulacao.bind(this),
        });
    }

    resetarSimulacao() {
        this.filterStore.clearFilters();
        this.viewStore.alteraTela(E_TIPO_TELA.Filtro);
        this.viewStore.resetarSimulacao();
    }

    render() {
        const dados = this.dataStore.dadosModalidade;
        const totalGeral = dados.Servicos.reduce((total, servico) => total + servico.Total, 0);
        const totalIss = dados.Servicos.reduce((total, servico) => total + servico.ValorIss, 0);
        const totalPis = dados.Servicos.reduce((total, servico) => total + servico.ValorPis, 0);
        const totalCofins = dados.Servicos.reduce((total, servico) => total + servico.ValorCofins, 0);

        let columns = [...this.colunas]
        let totalImpostos = totalIss;
        if (this.dataStore.dadosModalidade.EhNacional) {
            columns = columns.concat(this.colunasImpNacional);
            totalImpostos += totalPis;
            totalImpostos += totalCofins;
        }
        return (
            <div className="d-flex flex-column align-items-center">
                <Col xs={11} sm={11} md={11} lg={11} xl={11} className="">
                    <Row className="d-flex align-items-baseline justify-content-between px-3">
                        <div>
                            <Button size="sm" className="btn-com-bordas-primary btn-filtrar" onClick={() => this.downloadResumo()} > 
                                <Pdf cor="#fff" width="15"/>
                                &nbsp; Resumo 
                            </Button>
                            <Button size="sm" className="btn-com-bordas-primary btn-filtrar" onClick={() => this.handleEmailClick()} > 
                                <IconeMailBulk cor="#fff" tamanho="lg"/>
                                &nbsp; Email 
                            </Button>
                            <HelpButton className="m-3" href="https://atendimento.teconsvonline.com.br/hc/pt-br/articles/27100081298445-Calculadora-de-Servi%C3%A7os-e-Pre%C3%A7os-Wilson-Sons-Tecon-Salvador" />
                        </div>
                    </Row>
                    <div className="font-weight-bold my-3"><IconeAtencao tamanho="lg" className="mr-1"/>{dados.AvisoImportante}</div>
                    <Card className="bg-white area-form mb-0 pb-0 px-0" >                
                        <Row className="h-100 pb-0">
                            <LoadingWhapper {...dados} >
                                {dados.dadosLabel.map((item, index) => (
                                    <Col key={index} sm={4} className="d-flex justify-content-start">
                                        <Fragment>
                                            <Label className="label-secondary mr-1">{item[0]}:</Label>
                                            <Label className="label-disabled">{item[1]}</Label>
                                        </Fragment>
                                    </Col>                                        
                                ))}
                            </LoadingWhapper>
                        </Row>
                        <LoadingWhapper {...dados} >
                            {dados.dadosProcessos.map((processo, index) => (
                                <Fragment key={index} >
                                    <hr className="m-2" />
                                    <Row>
                                        {processo.dadosLabel.map((item, index) => (
                                            <Col key={index} sm={4} className="d-flex justify-content-start">
                                                <Fragment>
                                                    <Label className="label-secondary mr-1">{item[0]}:</Label>
                                                    <Label className="label-disabled">{item[1]}</Label>
                                                </Fragment>
                                            </Col>                                        
                                        ))}                                     
                                    </Row>
                                </Fragment>
                            ))}
                        </LoadingWhapper>
                    </Card>
                    <Card className="bg-white area-form mb-0 pb-0 px-0" >
                        <div id="tableHeaderFixed" className="tabela-overflow-paginated border pt-1" style={{ height: '300px'}}>
                            <BootstrapTable
                                bootstrap4
                                striped
                                condensed
                                hover
                                bordered={false}
                                classes="tabela tabela-layout mb-0"
                                keyField='Id'
                                data={[...dados.Servicos]}
                                columns={columns}
                            />
                        </div>
                        <div className="d-flex flex-column align-items-center mt-2">
                            <Label className="">Valor Total:</Label>
                            <div className="d-flex justify-content-center align-items-center" 
                                style={{ backgroundColor: '#EBEBEB', width: '200px', height: '30px', borderRadius: '5px' }}>
                                <Label className="font-weight-bold mb-0" style={{fontSize: '15px'}}>{formatarReal(totalGeral)}</Label>
                            </div>
                            <Label className="">Valor aprox. dos Trib. Fed., Estad. e Munic.:</Label>
                            <div className="d-flex justify-content-center align-items-center" 
                                style={{ backgroundColor: '#EBEBEB', width: '200px', height: '30px', borderRadius: '5px' }}>
                                <Label className="font-weight-bold mb-0" style={{fontSize: '15px'}}>{formatarReal(totalImpostos)}</Label>
                            </div>
                        </div>
                    </Card>
                    <Card className="bg-white area-form mb-0 pb-0 mt-3 px-0" >
                        <h4 className="text-center font-weight-bold mb-0 pb-0">Normas de Aplicação</h4>
                        {dados.ItemsNormaAplicacao.map(({DescNorma}, index) => (
                            <div key={index} className="mb-3">                                
                                <IconeGenerico icone="circle" className="mr-2"/> {DescNorma} &nbsp;
                            </div>
                        ))}
                        {dados.ItemsNormaAplicacaoComum.map(({DescNorma}, index) => (
                            <div key={index} className="mb-3">                                
                                <IconeGenerico icone="circle" className="mr-2"/> {DescNorma} &nbsp;
                            </div>
                        ))}                        
                        <Row className="d-flex justify-content-center mt-3">
                            <div className="float-right mr-4">
                                <Button size="lg" block className="btn-com-bordas-primary btn-filtrar mr-3" onClick={() => this.voltarClick()}>                                
                                    <IconeSetaEsquerda cor="#fff" />
                                    &nbsp; Voltar 
                                </Button>
                            </div>
                            <div className="float-right">
                                <Button size="lg" block className="btn-com-bordas-primary btn-filtrar" onClick={() => this.novaSimulacao()}>                                
                                    &nbsp; Nova Simulação
                                </Button>
                            </div>
                        </Row>
                    </Card>
                </Col>
            </div> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/ResultadoSimulacao.js